<div class="p-5 condiciones">
  <h3 class="titulo">Términos y condiciones</h3>

  <hr />

  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="p-4 rounded" style="background-color: #ffffff08">
          <h5 class="mb-4 subTitulo">Términos de uso de +Cinemateca</h5>

          <p>
            +Cinemateca es un servicio de Video on Demand (VOD) de Cinemateca Uruguaya. Es una plataforma que permite a
            nuestros
            usuarios acceder a películas y materiales de archivo a través de computadoras y otros dispositivos con
            acceso a
            internet.</p>
          <p>
            Las presentes condiciones regulan el acceso a los contenidos y a todos los servicios ofrecidos por
            CINEMATECA a través
            del <a href="https://www.mascinemateca.org.uy">www.mascinemateca.org.uy</a>. No obstante, CINEMATECA se
            reserva el derecho a modificar la presentación,
            configuración y
            contenido del sitio web, así como también las condiciones requeridas para su acceso y/o utilización.</p>
          <p>
            Antes de contratar una membrecía a +Cinemateca el Usuario deberá leer atentamente las Condiciones Generales
            creadas a
            tal efecto por CINEMATECA. El acceso, navegación y uso de www.mascinemateca.org.uy conllevan y supone la
            aceptación por
            el Usuario del presente Aviso Legal y las Condiciones Generales que incluye.</p>
          <b>Sobre Cinemateca</b>
          <p>
            Cinemateca Uruguaya es una filmoteca uruguaya con sede en Montevideo, Uruguay, fundada el 21 de abril de
            1952. Es una
            asociación civil sin fines de lucro que tiene como objetivo contribuir al desarrollo de la cultura
            cinematográfica y
            artística en general. Tiene su sede en Bartolomé Mitre 1236, en el barrio de Ciudad Vieja.</p>
          <b>Condiciones Generales de Uso</b>
          <p>
            El acceso a la información sobre los contenidos y sobre los servicios proporcionados por +CINEMATECA tiene
            carácter
            gratuito. Sin embargo, el acceso y disfrute de los contenidos audiovisuales están sujetos a registro,
            contratación
            previa y al pago de una membrecía.</p>
          <p>
            El acceso a este sitio web por parte de menores de edad es de estricta responsabilidad de sus padres o
            tutores legales,
            los cuales serán considerados como responsables de los actos que lleven a cabo los menores a su cargo,
            conforme a la
            normativa vigente.</p>
          <p>
            El servicio de +Cinemateca y todo el contenido visto en él son solo para uso personal, no comercial, y las
            credenciales
            de acceso no debe compartirse. El Usuario se compromete a hacer un uso diligente de su contraseña y
            mantenerla en
            secreto, no transmitiéndola a ningún tercero.</p>
          <p>
            Es obligación del Usuario notificar de forma inmediata a los gestores de www.mascinemateca.org.uy acerca de
            cualquier
            hecho que permita el uso indebido de los identificadores y/o contraseñas, tales como el robo, extravío, o el
            acceso no
            autorizado a los mismos, con el fin de proceder a su inmediata cancelación. Mientras no se comuniquen tales
            hechos,
            CINEMATECA quedará eximida de cualquier responsabilidad que pudiera derivarse del uso indebido de los
            identificadores o
            contraseñas por terceros no autorizados.</p>
          <p>
            El presente sitio web se rige por las leyes uruguayas y por la legislación nacional e internacional sobre
            propiedad
            intelectual e industrial. En ningún caso se entenderá que el acceso y navegación del Usuario o la
            utilización,
            adquisición y/o contratación de Servicios de CINEMATECA, implique una renuncia, transmisión, licencia o
            cesión total ni
            parcial de dichos derechos por parte de CINEMATECA.</p>
          <p>
            Quedan reservados todos los derechos de Propiedad Intelectual e Industrial sobre los Contenidos y/o
            Servicios y, en
            particular, queda prohibido modificar, copiar, reproducir, comunicar públicamente, transformar o distribuir
            de cualquier
            forma la totalidad o parte de los Contenidos y/o Servicios incluidos en www.mascinemateca.org.uy, para
            propósitos
            públicos o comerciales, si no se cuenta con la autorización previa, expresa y por escrito de CINEMATECA o,
            en su caso,
            del titular de los derechos correspondientes.</p>
          <p>
            CINEMATECA se reserva el derecho de excluir al Usuario del Servicio activo, sin previo aviso, en caso de que
            lleve a
            cabo alguna de las actividades anteriores contrarias a la ley.</p>
          <p>
            CINEMATECA no será responsable en caso de que existan interrupciones del servicio, demoras, errores, mal
            funcionamiento
            del mismo y, en general, demás inconvenientes que tengan su origen en causas que escapan de su control y/o
            tenga por
            origen causas de fuerza mayor.</p>
          <p>
            CINEMATECA tendrá derecho, sin que exista indemnización alguna al Usuario por estos conceptos, a suspender
            temporalmente
            los Servicios y Contenidos de www.mascinemateca.org.uy para efectuar operaciones de mantenimiento, mejora o
            reparación
            de los mismos. En el supuesto de que la interrupción que se efectúe tenga carácter definitivo, se notificará
            previamente
            a los Usuarios.</p>
          <b>Condiciones Generales de Membresía</b>
          <p>

            +Cinemateca ofrece diversos planes de membresía. Las mismas tienen condiciones y limitaciones diferentes que
            se aclaran
            en el acuerdo de suscripción o en otras comunicaciones. Podrá encontrar la información específica sobre su
            membresía de
            +Cinemateca visitando www.mascinemateca.org.uy y haciendo clic en el vínculo “Cuenta”, disponible en la
            parte superior
            de las páginas bajo su nombre de perfil.</p>
          <p>
            La asociación mínima a +Cinemateca es por tres meses. Una vez transcurrido ese tiempo su membresía puede ser
            cancelada o
            continuar hasta que el usuario así lo determine.</p>
          <p>
            Para usar el servicio de +Cinemateca, debe tener acceso a internet y un dispositivo listo para ver
            contenidos
            audiovisuales por streaming. Debe proporcionar una o más Formas de pago, válida y aceptada, que pueda
            actualizarse
            periódicamente y que admita pagos a través de terceros. A menos que cancele su membresía antes de la fecha
            de
            facturación, nos autoriza a cobrarle la membresía del siguiente ciclo de facturación a su Forma de pago.</p>
          <p>

            Ocasionalmente, podríamos hacer ofertas especiales de promociones, planes o membresías. Los usuarios con una
            membresía
            de +Cinemateca existente o reciente podrían no ser elegibles para acceder a este tipo de promociones.</p>
          <p>
            Los cargos de membresía por el servicio de +Cinemateca se cobrarán a su Forma de pago en la fecha de pago
            específica
            indicada en la página “Cuenta”. La duración de su ciclo de facturación dependerá del tipo de membresía que
            haya
            seleccionado al suscribirse al servicio. En ciertos casos, su fecha de pago podría cambiar, por ejemplo, si
            no se pudo
            hacer el cobro con su Forma de pago satisfactoriamente, cuando cambie su plan de suscripción, o si su
            membresía pagada
            comenzó un día que no está incluido en un determinado mes.</p>
          <p>
            Para usar el servicio de +Cinemateca debe proveer una forma de pago con tarjeta de crédito. Nos autoriza a
            hacer cargos
            a cualquier forma de pago asociada con su cuenta en caso del rechazo o indisponibilidad de su forma de pago
            principal.
            Cualquier cargo pendiente le corresponderá a usted. Si el pago no se pudiera hacer satisfactoriamente,
            debido a la fecha
            de vencimiento, la falta de fondos o si usted no actualiza la información de su forma de pago o cancela su
            cuenta,
            podemos suspender su acceso al servicio hasta que obtengamos una forma de pago válida.</p>
          <p>
            Puede cancelar la membresía de +Cinemateca en cualquier momento, luego de los de haber abonado los primeros
            3 meses de
            uso. En la medida permitida por la ley aplicable, los pagos no son reembolsables y no se otorgarán
            reembolsos ni
            créditos por los periodos de membresía utilizados parcialmente o por el contenido de +Cinemateca no visto.
            Para
            cancelar, visite la página “Cuenta” y siga las instrucciones. Si cancela su membresía, su cuenta se cerrará
            automáticamente al final de su período de facturación actual.</p>
          <p>
            Cinemateca tiene derecho a cambiar los planes de suscripción y el precio de nuestro servicio de vez en
            cuando. Sin
            embargo, cualquier cambio en los precios o en los planes de suscripción se aplicará no antes de los 30 días
            siguientes a
            la notificación.</p>
          <p>
            La calidad de la imagen del contenido de +Cinemateca puede variar de dispositivo a dispositivo y puede verse
            afectada
            por diversos factores, tales como la ubicación, el ancho de banda disponible o la velocidad de la conexión a
            internet.
            La disponibilidad del contenido en alta definición (HD) depende de su servicio de internet y del dispositivo
            en uso.

          </p>
        </div>
      </div>

      <div class="col-12 mt-4">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="customCheck1" [(ngModel)]="condiciones"
            name="condiciones" />
          <label class="custom-control-label" for="customCheck1"><strong> Acepto los términos y condiciones </strong>
          </label>
        </div>
      </div>

      <div class="col-12">
        <button class="btn btn-primary btn-lg col-12 col-lg-6 offset-lg-3 mt-3 mb-4" data-dismiss="modal"
          (click)="continuar()">
          <span> <i class="fas fa-times mr-2"></i> CONTINUAR</span>
        </button>
      </div>
    </div>
  </div>
</div>